import AbstractComponent from './abstractComponent';

export default class NavigationHover extends AbstractComponent {
	/**
	 * @param {string} element - Selector
	 * @param {Object} options - User options
	 */
	constructor(element, options) {
		super(options);
		window.addEventListener('DOMContentLoaded', () => {
			this.initEvents();
		});
	}

	/**
	 * Initialize events
	 * @param {string} triggers - Selectors
	 */
	initEvents() {
		const items = document.querySelectorAll('.header .navigation--secondary .navigation__list > .has-children');

		items.forEach((item) => {
			let timerHandle = null;
			// item.addEventListener('mouseenter', () => {
			// 	clearTimeout(timerHandle);
			// 	timerHandle = setTimeout(() => {
			// 		item.classList.add('is-active-js');
			// 		document.querySelector(".body--home")?.classList.add("is-active-menu-js");
			// 	}, 300);
			// });
			// item.addEventListener('mouseleave', () => {
			// 	clearTimeout(timerHandle);
			// 	if (item.classList.contains('is-active-js')) {
			// 		timerHandle = setTimeout(() => {
			// 			item.classList.remove('is-active-js');
			// 			document.querySelector(".body--home")?.classList.remove("is-active-menu-js");
			// 		}, 300);
			// 	}
			// });

			item.addEventListener('click', () => {
				clearTimeout(timerHandle);
				if (item.classList.contains('is-active-js')) {
					timerHandle = setTimeout(() => {
						item.classList.remove('is-active-js');
						document.querySelector(".body--home")?.classList.remove("is-active-menu-js");
					}, 300);
				}
				else{
					item.classList.add('is-active-js');
				}
			});
			
		});
	}
}
